import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SiteLayout, ScrollToTop } from '@/shared/components/SiteLayout';
import {
  AboutPage,
  ContactPage,
  HomePage,
  NotFoundPage,
  ProductsPage,
  ProjectsPage,
  ServicesPage,
  WhySolarPage
} from '@/features';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/why-solar" element={<WhySolarPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </SiteLayout>
    </BrowserRouter>
  );
};
